import { Component, OnDestroy, OnInit } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'search-loading-placeholder',
  templateUrl: './search-loading-placeholder.component.html',
  // standalone: true,
  // imports: [CommonModule, LottieComponent],
})
export class SearchLoadingPlaceholder implements OnInit, OnDestroy {
  questionContentAnimationOptions: AnimationOptions = {
    path: 'assets/images/lottie-img/question-content-animation.json',
  };
  constructor() {}
  ngOnInit(): void {}
  ngOnDestroy(): void {}
}
